/* Stykhia sticky bar (snippets/sm-sticky-cta.liquid).
   Product page: shown while the main Add to Cart button is off screen. Its button does nothing of its own:
   it calls .click() on the MAIN Add to Cart button inside <product-form>, so the same checks run
   (assets/sm-portrait.js, assets/sm-upload.js: message next to the field and a scroll to the first missing
   one) and Dawn's product-form.js adds to the cart exactly as after a real click. No form, no cart request.
   The price follows the price in the main button.
   Elsewhere: a plain link; on the home page it waits until the hero button has left the screen. */
(function () {
  var bar = document.querySelector('[data-sm-sticky-cta]');
  if (!bar) return;

  function watch(target, onChange) {
    if (!target || !('IntersectionObserver' in window)) return false;
    new IntersectionObserver(function (entries) {
      onChange(entries[0].isIntersecting);
    }).observe(target);
    return true;
  }

  function show(visible) {
    bar.classList.toggle('sm-sticky-cta--away', !visible);
  }

  /* room under the footer on desktop too (on phones it is always there) */
  if (bar.classList.contains('sm-sticky-cta--all')) document.body.classList.add('sm-has-sticky-bar');

  if (bar.dataset.smMode === 'buy') {
    var submit = document.querySelector('#buy product-form [type="submit"][name="add"]') ||
      document.querySelector('product-form [type="submit"][name="add"]');
    var button = bar.querySelector('[data-sm-sticky-buy]');
    if (!submit || !button) {
      bar.remove();
      return;
    }

    /* price: the same as in the main button ("Add to Cart · $X", assets/sm-product.js) */
    var priceEl = bar.querySelector('[data-sm-sticky-price]');
    var mainPrice = submit.querySelector('[data-sm-btn-price]');
    function syncPrice() {
      if (!priceEl || !mainPrice || mainPrice.hidden) return;
      var text = mainPrice.textContent.replace(/^\s*·\s*/, '').trim();
      if (text) priceEl.textContent = text;
    }
    function syncState() {
      button.disabled = submit.disabled;
    }
    if (mainPrice) new MutationObserver(syncPrice).observe(mainPrice, { childList: true, characterData: true, subtree: true });
    new MutationObserver(syncState).observe(submit, { attributes: true, attributeFilter: ['disabled'] });
    syncPrice();
    syncState();

    button.addEventListener('click', function () {
      submit.click();
    });

    show(false);
    bar.hidden = false;
    if (!watch(submit, function (onScreen) { show(!onScreen); })) show(true);
    return;
  }

  /* link: on the home page out of the way while the hero button is on screen */
  var hero = document.querySelector('.sm-hero__button');
  bar.hidden = false;
  if (!watch(hero, function (onScreen) { show(!onScreen); })) show(true);
})();
